export default {
  'payment.stats.paidAmount': '已支付金额',
  'payment.stats.paidCount': '支付成功次数',
  'payment.stats.attempts': '支付次数',
  'payment.stats.orders': '订单数',
  'payment.stats.successRate': '支付成功率',
  'payment.stats.aliasCount': '账号数',
  'payment.stats.paidCountHint': '区间内成功支付流水条数',
  'payment.stats.paidCountHintDeduped': '区间内已支付订单数（按别名，去重）',
  'payment.stats.attemptsHint': '区间内全部支付流水',
  'payment.stats.ordersHint': '区间内订单数（按别名，去重）',
  'payment.stats.successHint': '成功 {paid} / 尝试 {attempts}',
  'payment.stats.successHintDeduped': '已支付 {paid} / 订单 {orders}',
  'payment.chart.title': '别名金额 TOP',
  'payment.chart.desc': '按别名汇总，仅展示前 {limit} 名，其余并入「其他」',
  'payment.chart.descDeduped':
    '按订单去重汇总，仅展示前 {limit} 名，其余并入「其他」',
  'payment.table.title': '对账明细',
  'payment.table.desc':
    '按 pay_config.alias：支付次数、成功次数、成功率与已支付金额（时间范围与分桶均为 updated_at）',
  'payment.table.descFull':
    '按 pay_config.alias：支付次数、成功次数、成功率与已支付金额（时间范围与分桶均为 updated_at，含连抛/重试）',
  'payment.table.descDeduped':
    '按 pay_config.alias：订单数、已支付订单数、成功率与已支付金额（按订单+别名+分桶去重；时间范围与分桶均为 updated_at）',
  'payment.table.modeTotal': '汇总',
  'payment.table.modeDetail': '按日',
  'payment.table.search': '搜索账号别名…',
  'payment.table.rowCount': '共 {count} 条',
  'payment.table.empty': '暂无支付账号统计',
  'payment.table.bucketDay': '日期',
  'payment.table.bucketHour': '时段',
  'payment.table.bucketMonth': '月份',
  'payment.table.alias': '账号别名',
  'payment.table.attempts': '支付次数',
  'payment.table.orders': '订单数',
  'payment.table.success': '成功',
  'payment.table.successRate': '成功率',
  'payment.table.paidAmount': '已支付金额',
  'payment.table.otherAliases': '其他 ({count} 个别名)',
  'payment.chart.countLineDeduped': '已支付 {paid} / 订单 {orders}',
  'payment.filters.statMode': '统计口径',
  'payment.filters.statModeDeduped': '按订单去重',
  'payment.filters.statModeFull': '全量流水',
  'payment.filters.groupBy': '分桶粒度',
  'payment.filters.groupByDay': '按天',
  'payment.filters.groupByHour': '按小时',
  'payment.filters.groupByMonth': '按月',
};
